import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useGetFilingInformationQuery } from '../../generated/telecomGraphqlService'

export default function Footer(): JSX.Element {
  const classes = useStyles()
  const { t } = useTranslation()
  const { data, isLoading: isLoadingSupportPhones } = useGetFilingInformationQuery({}, { cacheTime: 3600 })
  const supportPhones = data?.filingInformation.supportPhones.join(' or ') ?? '-'

  return (
    <Box component="footer" className={classes.container}>
      <hr className={classes.separator} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row', md: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {isLoadingSupportPhones && <LinearProgress />}
        {data && !isLoadingSupportPhones && (
          <Typography>{t('technicalSupportContact', { supportPhones })}</Typography>
        )}
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  separator: {
    width: '100%',
    borderTop: '1px solid #bbb',
  },
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}))
